<div class="w3-sidebar w3-bar-block w3-animate-left sidebar-transition" id="mySidebar2">
    <div [ngClass]="{'covered_slider': !showAllDetails}" class="position-relative">
        <div class="mb-3 mt-3 ml-1" *ngIf="showExperienceDetails || showAdditionalDetails || showEducationDetails ||showBasicDetails">
            <i class="fas fa-arrow-left pointer" (click)="showAllDetail('details');"> <span class="font-weight-500 f-14 ml-2 f-poppins"> Back </span> </i>
        </div>
        <div class="mb-3 mt-3 ml-1" *ngIf="showEditContacts">
            <i class="fas fa-arrow-left pointer" (click)="showAllDetail('contact');"> <span class="font-weight-500 f-14 ml-2 f-poppins"> Back </span> </i>
        </div>

        <div class="mt-3">
            <div class="row mb-3 justify-content-between d-flex" *ngIf="showAllDetails || showBasicDetails">
                <div class="canProfilePic position-relative ml-4">
                    <i class="fas fa-user text-dis" *ngIf="!basicdetails?.candidateimage"></i>
                    <img src="{{basicdetails?.candidateimage}}" class="img-fluid" alt="None" *ngIf="basicdetails?.candidateimage" />
                </div>
                <div class="col text-capitalize d-flex justify-content-between">
                    <div class="" *ngIf="!showBasicDetails">
                        <p class="font-weight-600 f-14 mb-1">{{basicdetails?.firstname}} {{basicdetails?.middlename}} {{basicdetails?.lastname}} 
                            <span *ngIf="basicdetails?.is_unsubscribed" matTooltip="Unsubscribed from Email Campaign" [matTooltipClass]="{ 'red-tooltip text-black': true }" class="px-1 ml-1" style="color: #e54f7a; background-color: #fff5f8; border-radius: 100px;">
                                <i class="fa-solid fa-envelopes-bulk f-12"></i>
                            </span>
                        </p>
                        <p class="f-14 mb-1">
                            <span class="line-clamp" matTooltip="{{basicdetails?.jobtitle | titlecase}} at {{basicdetails?.companyname | titlecase}}" [matTooltipClass]="{ 'red-tooltip': true }">
                                {{basicdetails?.jobtitle}} <span *ngIf="basicdetails?.companyname"> at </span>{{basicdetails?.companyname}}
                            </span>
                        </p>
                        <div class="d-flex" *ngIf="showAllDetails || showBasicDetails">
                            <div class="f-12 mb-1 text-9696 d-flex align-items-center">
                                <i class="far fa-map-marker-alt mr-1" *ngIf="basicdetails?.locationname"></i> {{basicdetails?.locationname}}
                                <i class="fa-solid fa-circle mx-2" style="font-size: 4px;" *ngIf="basicdetails?.totalexperience && basicdetails?.locationname"></i>
                                <i class="fa-regular fa-briefcase mr-1" *ngIf="basicdetails?.totalexperience"></i><span> {{getFormattedTenure(basicdetails?.totalexperience)}}</span>
                                <i class="fa-solid fa-circle mx-1" *ngIf="(basicdetails?.locationname || basicdetails?.totalexperience) && (basicdetails?.profileurl || twitter_url || facebook_url || github_url)" style="font-size: 5px;"></i>
                                <div class="mr-3 pointer" *ngIf="basicdetails?.profileurl" title="Linkedin">
                                    <a data-testid="auto-app-candidate-slider-a-1" class="f-14 text-black" (click)="openUrl(basicdetails?.profileurl, 'linkedin')" [ngClass]="{'p-none' : basicdetails?.profileurl.includes('****')}">
                                        <i class="fa fa-linkedin-square" style="color: #0652ba;" [ngClass]="{'text-9696' : basicdetails?.profileurl?.includes('****')}"></i>
                                    </a>
                                </div>
                                <div class="mr-3" *ngIf="twitter_url" title="{{twitter_url?.platformname}}">
                                    <a data-testid="auto-app-candidate-slider-a-2" class="f-14 text-black" (click)="openUrl(twitter_url?.link, 'twitter')" [ngClass]="{'p-none' : twitter_url?.link.includes('****')}">
                                        <i class="fa-brands fa-square-x-twitter" style="color: #000000;" [ngClass]="{'text-9696' : twitter_url?.link.includes('****')}"></i>
                                    </a>
                                </div>
                                <div class="mr-3" *ngIf="facebook_url" title="{{facebook_url?.platformname}}">
                                    <a data-testid="auto-app-candidate-slider-a-3" class="f-14 text-black" (click)="openUrl(facebook_url?.link, 'facebook')" [ngClass]="{'p-none' : facebook_url?.link.includes('****')}">
                                        <i class="fab fa-facebook" style="color: #1773ea;" [ngClass]="{'text-9696' : facebook_url?.link.includes('****')}"></i>
                                    </a>
                                </div>
                                <div class="mr-3" *ngIf="github_url" title="{{github_url?.platformname}}">
                                    <a data-testid="auto-app-candidate-slider-a-4" class="f-14 text-black" (click)="openUrl(github_url?.link, 'github')" [ngClass]="{'p-none' : github_url?.link?.includes('****')}">
                                        <i class="fab fa-github f-16" style="color: black;" [ngClass]="{'text-9696' : github_url?.link?.includes('****')}"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex" *ngIf="showAllDetails">
                        <p *ngIf="emailsdetails.length > 0">
                            <span class="mr-2 ats-cta-btn" title="Send email"> <i class="fas fa-envelope f-12" (click)="OpenSendEmailModule()"></i> </span>
                        </p>
                        <span class="dropdown ats-dropBtn mx-1 mt-1">
                            <button data-testid="auto-app-candidate-slider-button-1" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton" appDropdownToggle aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-ellipsis-v f-16 gray-text"></i>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="userDropdownButton">
                                <a data-testid="auto-app-candidate-slider-a-5" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="openAddToEmailCampaign()"> <i class="fa-solid fa-envelopes-bulk mr-2"></i>Add to Email Campaign </a>
                                <a data-testid="auto-app-candidate-slider-a-6" class="dropdown-item f-12 isActive mr-2 text-nowrap" routerLinkActive="active" (click)="openAddTalentpoolModal()"> <i class="fa-solid fa-users mr-2"></i>Add to Talent pool</a>
                                <a data-testid="auto-app-candidate-slider-a-7" class="dropdown-item f-12 isActive mr-2 text-nowrap" routerLinkActive="active" (click)="openAddToScreenAiModal()"> <i class="fa-solid fa-globe mr-2"></i>Add to Screen AI</a>
                                <!-- <a data-testid="auto-app-candidate-slider-a-8" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="EditContactDetails()"> <i class="fa-solid fa-user-pen mr-2"></i>Edit Profile</a> -->
                                <a data-testid="auto-app-candidate-slider-a-9" class="dropdown-item f-12 isActive mr-2" *ngIf="isCurrentUserTheCreator" routerLinkActive="active" (click)="deletecandidatemodal()"> <i class="fa-solid fa-inbox mr-2"></i>Archive</a>
                                <a data-testid="auto-app-candidate-slider-a-10" class="dropdown-item f-12 isActive mr-2" routerLinkActive="active" (click)="exportToPDF()"> <i class="fa-solid fa-download mr-2"></i>Export to PDF </a>
                                <a data-testid="auto-app-candidate-slider-a-11" class="dropdown-item text-webbtree-green f-12" *ngIf="!aegisCandidateData && isAegisConnected" (click)="addToAegis()">
                                    <img style="height: 20px; width: 20px;" src="../../../assets/search/aegis.png" alt="A">Add to Aegis
                                </a>
                            </div>
                        </span>
                    </div>
                </div>
            </div>

            <div class="d-flex" *ngIf="showAllDetails || showBasicDetails">
                <span class="mr-3" style="color: #2e93a1;"><i class="fa-solid fa-tag"></i> Tags:</span>
                <span class="dropdown2">
                    <button data-testid="auto-app-candidate-slider-button-2" class="ats-btn btn-break addTags ml-3px" id="tagid" #tagcheck (click)="showdropdown()" type="button" aria-haspopup="true" aria-expanded="false">
                        <span class=""><i class="fa-solid fa-plus"></i></span>
                    </button>
                    <div class="dropdown-content" id="dropdowndata">
                        <div class="position-relative">
                            <div class="text-right closeicon f-14"><i class="fas fa-times" (click)="closedropdown()"></i></div>
                            <div class="custom-input">
                                <input data-testid="auto-app-candidate-slider-input-1"
                                    type="text"
                                    placeholder="Enter Tags"
                                    [(ngModel)]="tagtext"
                                    class="wc-form-control mb-1"
                                    (keyup.enter)="createTag();"
                                    [matAutocomplete]="tag_auto"
                                    (click)="searchTags($event.target.value)"
                                    (input)="searchTags($event.target.value)"
                                />
                                <mat-autocomplete #tag_auto="matAutocomplete">
                                    <mat-option *ngFor="let tagData of tags" (onSelectionChange)="addTag(tagData);">{{tagData.tagtext}}</mat-option>
                                </mat-autocomplete>
                            </div>
                        </div>
                        <span class="mb-0 f-12 text-danger">{{tagErrorMessage}}</span>
                        <div class="d-flex justify-content-between align-items-start mt-1">
                            <div style="width: calc(100% -  35px);">
                                <span class="tagslabel mb-2" *ngFor="let tag of tagArray">
                                    <span class="tagicon"><i class="fa-solid fa-tag"></i></span>
                                    <span class="text-truncate mx-2 text-9696" style="max-width: 205px;"  matTooltip="{{tag?.tagtext}}" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{tag?.tagtext}}</span>
                                    <span><i class="fa-solid fa-close" (click)="remove(tag?.tagid)"></i></span>
                                </span>
                            </div>
                            <div style="width: 25px;">
                              <span class="f-12 font-weight-600 pointer" style="color: #2dc3a5; margin-right: 3px; margin-top: 3px;" (click)="addtags()">Add</span>
                            </div>
                        </div>
                    </div>
                </span>
                <span class="" id="tagdata" [ngClass]="{'tagboxheight':tagList?.length>0}">
                    <span class="d-flex flex-wrap ml-2">
                        <span class="tagslabel onHover mb-2" *ngFor="let tag of tagList">
                            <span class="tagicon"><i class="fa-solid fa-tag"></i></span>
                            <span class="text-truncate">{{tag?.tagtext}}</span>
                            <span class="ml-2 pointer" (click)="unselect(tag.tagid)"> <i class="fal fa-times"></i></span>
                        </span>
                    </span>
                </span>
                <div *ngIf="tagList && tagList.length>5" class="d-flex align-items-end">
                    <span class="text-webbtree-green text-right f-12 pb-3" *ngIf="!tagmore"><span class="pointer" (click)="showmore()">View more</span></span>
                    <span class="text-webbtree-green text-right f-12 pb-3" *ngIf="tagmore"><span class="pointer" (click)="showless()">View less</span></span>
                </div>
            </div>

            <div class="row" style="display: flow-root;" *ngIf="showAllDetails || showBasicDetails">
                <div class="col" style="border-bottom: 1px solid #d9d9d9;">
                    <ul class="nav nav-pills my-0">
                        <li class="nav-item mr-3" (click)="onTabChange('details')">
                            <a data-testid="auto-app-candidate-slider-a-12" class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" href="#pills-profile" role="tab" #detailsslider [ngClass]="{'active': tabtoShow == 'details'}" aria-controls="pills-profile" aria-selected="true">
                                Profile
                            </a>
                        </li>
                        <li class="nav-item mr-3" (click)="onTabChange('files')">
                            <a data-testid="auto-app-candidate-slider-a-13" class="nav-link" id="pills-documents-tab" data-bs-toggle="pill" href="#pills-documents" role="tab" aria-controls="pills-documents" [ngClass]="{'active': tabtoShow == 'files'}" aria-selected="false">Files</a>
                        </li>
                        <li class="nav-item mr-3" (click)="onTabChange('contact')">
                            <a data-testid="auto-app-candidate-slider-a-14" class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" href="#pills-contact" role="tab" #contactslider [ngClass]="{'active': tabtoShow == 'contact'}" aria-controls="pills-contact" aria-selected="false">
                                Contacts
                            </a>
                        </li>
                        <li class="nav-item mr-3" (click)="onTabChange('notes')">
                            <a data-testid="auto-app-candidate-slider-a-15" class="nav-link" id="pills-notes-tab" data-bs-toggle="pill" href="#pills-notes" role="tab" #notesslider [ngClass]="{'active': tabtoShow == 'notes'}" aria-controls="pills-notes" aria-selected="false">Notes</a>
                        </li>
                        <li class="nav-item mr-3" (click)="onTabChange('taggedto')">
                            <a data-testid="auto-app-candidate-slider-a-16" class="nav-link" id="pills-taggedto-tab" data-bs-toggle="pill" href="#pills-taggedto" role="tab" #taggedtoslider [ngClass]="{'active': tabtoShow == 'taggedto'}" aria-controls="pills-taggedto" aria-selected="false">
                                Tagged to
                            </a>
                        </li>
                        <li class="nav-item" (click)="onTabChange('activity')">
                            <a data-testid="auto-app-candidate-slider-a-17" class="nav-link" id="pills-activities-tab" data-bs-toggle="pill" href="#pills-activities" role="tab" [ngClass]="{'active': tabtoShow == 'activity'}" aria-controls="pills-activities" aria-selected="false">Activity</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="row" *ngIf="showAllDetails">
                <div class="" [ngClass]="{'col pt-2': tabtoShow != 'contact', 'w-100': tabtoShow == 'contact'}">
                    <div class="tab-content" id="pills-tabContent">
                        <div *ngIf="!isProfileTabCalled && (tabtoShow === 'details') && showProfileLoader" class="w-100 d-flex justify-content-center">
                            <img src="../../assets/rolling-loader.gif" style="width: 50px;" alt="" />
                        </div>

                        <div *ngIf="isProfileTabCalled && tabtoShow == 'details'" class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" [ngClass]="{'show active': tabtoShow == 'details'}">
                       
                        <!-- Aegis Connection Card -->
                        <div class="aegis-connection mb-3" *ngIf="aegisCandidateData">
                            <div class="aegis-connection__header d-flex align-items-center justify-content-between px-3 py-2">
                                <div class="d-flex align-items-center">
                                    <span class="aegis-connection__logo-icon mr-2">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 2L4 6V12C4 16.42 7.45 20.55 12 22C16.55 20.55 20 16.42 20 12V6L12 2Z" fill="#2196A6"
                                                opacity="0.85" />
                                            <path d="M12 5L7 8V12C7 15.1 9.1 17.97 12 19C14.9 17.97 17 15.1 17 12V8L12 5Z" fill="white"
                                                opacity="0.5" />
                                        </svg>
                                    </span>
                                    <span class="aegis-connection__dot mx-2" style="color:#bbb">·</span>

                                    <span class="aegis-connection__name font-weight-700 f-15 mr-3 text-capitalize">
                                        {{ aegisCandidateData.mandates.length > 0 && aegisCandidateData.mandates[0].mandatename ?
                                        aegisCandidateData.mandates[0].mandatename : 'Mandate Not Available'}}
                                        {{ aegisCandidateData.mandates.length > 1 ? '+' + (aegisCandidateData.mandates.length - 1) : '' }}
                                    </span>
                                    <span class="aegis-connection__badge d-flex align-items-center">
                                        <span class="aegis-connection__badge-dot mr-1"></span>
                                        <span class="f-12">{{ aegisCandidateData.candidatetype }}</span>
                                    </span>
                                </div>
                                <a data-testid="auto-app-candidate-slider-a-18" *ngIf="aegisCandidateData?.atslink" [href]="aegisCandidateData?.atslink" target="_blank"
                                    rel="noopener noreferrer" class="aegis-connection__link f-13">
                                    View in Aegis
                                    <i class="fa-solid fa-arrow-up-right-from-square ml-1"></i>
                                </a>
                            </div>
                            <div class="aegis-connection__details d-flex align-items-center px-3 py-2">
                                <div class="aegis-connection__detail-item d-flex align-items-center mr-4">
                                    <i class="fa-regular fa-address-card aegis-connection__detail-icon mr-2"></i>
                                    <div>
                                        <div class="aegis-connection__detail-label f-11">Contact</div>
                                        <div class="aegis-connection__detail-value font-weight-600 f-13">{{ aegisCandidateData?.contacts ?
                                            'Available' : 'Not Available' }}</div>
                                    </div>
                                </div>
                                <div class="aegis-connection__detail-item d-flex align-items-center mr-4">
                                    <i class="fa-regular fa-clock-rotate-left aegis-connection__detail-icon mr-2"></i>
                                    <div>
                                        <div class="aegis-connection__detail-label f-11">Updated</div>
                                        <div class="aegis-connection__detail-value font-weight-600 f-13">
                                            <ng-container *ngIf="getFormatedDate(aegisCandidateData?.lastupdatedon) as lastUpdated">
                                                <span *ngIf="lastUpdated.text === 'Today'">Today</span>
                                                <span *ngIf="lastUpdated.text !== 'Today'">
                                                    {{ lastUpdated.value }} {{ lastUpdated.type }}{{ lastUpdated.value > 1 ? 's' : '' }} ago
                                                </span>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                                <div class="aegis-connection__detail-item d-flex align-items-center mr-4">
                                    <i class="fa-regular fa-folder aegis-connection__detail-icon mr-2"></i>
                                    <div>
                                        <div class="aegis-connection__detail-label f-11">Source</div>
                                        <div class="aegis-connection__detail-value font-weight-600 f-13">{{ aegisCandidateData?.source ||
                                            'N/A' }}</div>
                                    </div>
                                </div>
                                <div class="aegis-connection__detail-item d-flex align-items-center">
                                    <i class="fa-regular fa-circle-user aegis-connection__detail-icon mr-2"></i>
                                    <div>
                                        <div class="aegis-connection__detail-label f-11">Owner</div>
                                        <div class="aegis-connection__detail-value font-weight-600 f-13 text-capitalize">{{
                                            aegisCandidateData.mandates.length > 0 && aegisCandidateData.mandates[0].mandateowner ?
                                            aegisCandidateData.mandates[0].mandateowner : 'N/A' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Aegis Connection Card -->


                          <app-profile-tab [skillsData]="skillsdata" [basicDetails]="basicdetails" [experienceDetails]="experiencedetails" [educationDetails]="educationdetails" [interestDetails]="interestDetails" [candidateCertification] = "certificationDetails"
                            [isCurrentUserTheCreator]="isCurrentUserTheCreator" (childEvents)="childEventsHandler($event) " [events]="reverseComponentSubject.asObservable()">
                          </app-profile-tab>
                        </div>

                        <div  *ngIf="tabtoShow == 'files'" class="tab-pane fade" id="pills-documents" role="tabpanel" aria-labelledby="pills-documents-tab" [ngClass]="{'show active': tabtoShow == 'files'}">
                          <app-document-tab [basicdDetails]="basicdetails" [candidateId]="candidateid" (childEvents)="childEventsHandler($event)"></app-document-tab>
                        </div>

                        <div class="tab-pane fade w-100" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab" [ngClass]="{'show active': tabtoShow == 'contact'}">
                            <div *ngIf="callContactSlider">
                                <app-person-search-contact-slider [candidateDetails]="candidateContactObj" [bulkRevealContactStatus]="bulkRevealContactStatus" (handleOutputEvent)="eventHandler($event)" (revealContactEventEmitter)="getRevealContactStatus($event)"></app-person-search-contact-slider>
                              </div>
                        </div>

                        <div *ngIf="tabtoShow == 'notes'" class="tab-pane fade" id="pills-notes" role="tabpanel" aria-labelledby="pills-notes-tab" [ngClass]="{'show active': tabtoShow == 'notes'}">
                          <app-slider-notes-tab *ngIf="allcandidatedetails" [candidateId]="candidateid" [candidatedata]="allcandidatedetails" (passEntryEvent)="getnotesdata($event)"></app-slider-notes-tab>
                        </div>

                        <div *ngIf="tabtoShow == 'taggedto'" class="tab-pane fade" id="pills-taggedto" role="tabpanel" aria-labelledby="pills-taggedto-tab" [ngClass]="{'show active': tabtoShow == 'taggedto'}">
                          <app-taggedto-tab [candidatedata]="allcandidatedetails" (passEntryEvent)="getTaggeddata($event)"  (openModalEvent)="forwardEvent()"></app-taggedto-tab>
                        </div>

                        <div *ngIf="tabtoShow == 'activity'" class="tab-pane fade" id="pills-activities" role="tabpanel" aria-labelledby="pills-activities-tab" [ngClass]="{'show active': tabtoShow == 'activity'}">
                          <app-activity-tab [candidateid]="candidateid"></app-activity-tab>
                        </div>

                    </div>
                </div>
            </div>

            <!----------------------------------------------------- EditExperienceDetails ------------------------------------------------->
            <div *ngIf="showExperienceDetails" class="mr-2">
                <div class="row mb-5">
                    <div class="col d-flex justify-content-between">
                        <span class="font-weight-500">Experience Details</span>
                    </div>
                </div>
                <form [formGroup]="experience_form">
                    <div class="row mb-3px">
                        <div class="col-11">
                            <div class="f-12 font-weight-500 mb-4">
                                Job Title <span class="text-danger">*</span>
                                <input data-testid="auto-app-candidate-slider-input-2"
                                    (input)="searchJobs($event)"
                                    type="text"
                                    placeholder="Enter Job Title"
                                    #trigger="matAutocompleteTrigger"
                                    (keyup.enter)="trigger.closePanel()"
                                    class="wc-form-control nobg mt-2"
                                    formControlName="jobtitle"
                                    [matAutocomplete]="jobs_auto"
                                />
                                <mat-autocomplete #jobs_auto="matAutocomplete">
                                    <mat-option *ngFor="let job of joblist" [value]="job">
                                        {{job}}
                                    </mat-option>
                                </mat-autocomplete>
                                <p *ngIf="experience_form.get('jobtitle').errors?.required && (experience_form['controls'].jobtitle.dirty || experience_form['controls'].jobtitle.touched)" [ngClass]="['text-left','my-1','text-danger']">
                                    Jobtitle is required
                                </p>
                                <p *ngIf="experience_form['controls'].jobtitle.hasError('pattern')" class="text-danger f-12 pt-1">
                                    HTML tags are not allowed
                                </p>
                            </div>

                            <div class="f-12 font-weight-500 mb-4">
                                Company Name <span class="text-danger">*</span>
                                <input data-testid="auto-app-candidate-slider-input-3"
                                    (input)="searchCompany($event)"
                                    type="text"
                                    placeholder="Enter Company Name"
                                    #trigger="matAutocompleteTrigger"
                                    (keyup.enter)="trigger.closePanel()"
                                    class="wc-form-control nobg mt-2"
                                    formControlName="companyname"
                                    [matAutocomplete]="company_auto"
                                />
                                <mat-autocomplete #company_auto="matAutocomplete">
                                    <mat-option *ngFor="let company of companylist" [value]="company">
                                        {{company}}
                                    </mat-option>
                                </mat-autocomplete>
                                <p
                                    *ngIf="experience_form.get('companyname').errors?.required && (experience_form['controls'].companyname.dirty || experience_form['controls'].companyname.touched)"
                                    [ngClass]="['text-left','my-1','text-danger']"
                                >
                                    Company Name is required
                                </p>
                                <p *ngIf="experience_form['controls'].companyname.hasError('pattern')" class="text-danger f-12 pt-1">
                                    HTML tags are not allowed
                                </p>
                            </div>

                            <div class="f-12 font-weight-500 mb-4">
                                Work Location <span class="text-danger">*</span>
                                <input data-testid="auto-app-candidate-slider-input-4"
                                    (input)="searchLocation($event)"
                                    type="text"
                                    placeholder="Enter Work Location"
                                    #trigger="matAutocompleteTrigger"
                                    (keyup.enter)="trigger.closePanel()"
                                    class="wc-form-control nobg mt-2"
                                    formControlName="worklocation"
                                    [matAutocomplete]="location_auto"
                                />
                                <mat-autocomplete #location_auto="matAutocomplete">
                                    <mat-option *ngFor="let location of locationlist" [value]="location">
                                        {{location}}
                                    </mat-option>
                                </mat-autocomplete>
                                <p
                                    *ngIf="experience_form.get('worklocation').errors?.required && (experience_form['controls'].worklocation.dirty || experience_form['controls'].worklocation.touched)"
                                    [ngClass]="['text-left','my-1','text-danger']"
                                >
                                    Work Location is required
                                </p>
                                <p *ngIf="experience_form['controls'].worklocation.hasError('pattern')" class="text-danger f-12 pt-1">
                                    HTML tags are not allowed
                                </p>
                            </div>

                            <div class="d-flex align-items-center mb-4">
                                <label class="wc-checkbox mr-3 mb-0">
                                    <input data-testid="auto-app-candidate-slider-input-5" type="checkbox" id="mycheck" name="mycheck" (click)="currentlyWorkingChecked($event);" formControlName="currentyear" />
                                    <i class="fas fa-check"></i>
                                </label>
                                <label class="mb-0" for="mycheck">
                                    <span class="f-2">Currently Working</span>
                                </label>
                            </div>
                            <div class="row mb-4">
                                <span class="col-6">
                                    <label class="f-12 font-weight-500 mb-2"> Start Year <span class="text-danger">*</span> </label>
                                    <div class="position-relative">
                                        <select data-testid="auto-app-candidate-slider-select-1" class="nobg wc-form-control" formControlName="startyear">
                                            <option [value]="null" disabled selected>Start Year</option>
                                            <option *ngFor="let x of year_list" [value]="x">{{x}}</option>
                                        </select>
                                        <span class="selectdrop-down position-absolute tr0 p-none text-bluex"><i class="fas fa-calendar-minus f-12"></i> </span>
                                    </div>
                                    <p
                                        class="f-12 font-weight-500"
                                        *ngIf="experience_form.get('startyear').errors?.required && (experience_form['controls'].startyear.dirty || experience_form['controls'].startyear.touched)"
                                        [ngClass]="['text-left','my-1','text-danger']"
                                    >
                                        Start Year is required
                                    </p>
                                </span>
                                <span class="col-6" *ngIf="iscurrent == 0">
                                    <label class="f-12 font-weight-500 mb-2"> End Year <span class="text-danger">*</span> </label>
                                    <div class="position-relative">
                                        <select data-testid="auto-app-candidate-slider-select-2" class="nobg wc-form-control" formControlName="endyear">
                                            <option [value]="null" disabled selected>End Year</option>
                                            <option *ngFor="let x of year_list" [value]="x">{{x}}</option>
                                        </select>
                                        <span class="selectdrop-down position-absolute tr0 p-none text-bluex"><i class="fas fa-calendar-minus f-12"></i> </span>
                                    </div>
                                    <p
                                        class="f-12 font-weight-500"
                                        *ngIf="experience_form.get('endyear').errors?.required && (experience_form['controls'].endyear.dirty || experience_form['controls'].endyear.touched)"
                                        [ngClass]="['text-left','my-1','text-danger']"
                                    >
                                        End Year is required
                                    </p>
                                </span>
                            </div>
                            <p class="f-12 font-weight-500" *ngIf="experience_form['controls'].endyear.hasError('incorretexperience')" [ngClass]="['text-left','my-1','text-danger']">End year should be greater than start year.</p>

                            <p class="f-12 font-weight-500 mb-2">Work Description</p>
                            <textarea data-testid="auto-app-candidate-slider-textarea-1" type="text" placeholder="Enter Work Description " class="wc-form-control nobg mb-3 h-105" formControlName="workdescription"> </textarea>
                            <p *ngIf="experience_form['controls'].workdescription.hasError('pattern')" class="text-danger f-12 pt-1">
                                HTML tags are not allowed
                            </p>
                        </div>
                    </div>
                </form>
            </div>
            <!------------------------------------------------------- EditExperienceDetails --------------------------------------------------->

            <!------------------------------------------------------- showEducationDetails --------------------------------------------------->
            <div class="mr-2" *ngIf="showEducationDetails">
                <div class="row mb-5">
                    <div class="col d-flex justify-content-between">
                        <span class="font-weight-500">Education Details</span>
                    </div>
                </div>
                <form [formGroup]="education_form">
                    <div class="row mb-3px">
                        <div class="col-11">
                            <div class="f-12 font-weight-500 mb-4">
                                Degree <span class="text-danger">*</span>
                                <input data-testid="auto-app-candidate-slider-input-6"
                                    (input)="searchDegree($event)"
                                    type="text"
                                    placeholder="Enter Degree"
                                    #trigger="matAutocompleteTrigger"
                                    (keyup.enter)="trigger.closePanel()"
                                    class="wc-form-control nobg mt-2"
                                    formControlName="degree"
                                    [matAutocomplete]="degree_auto"
                                />

                                <mat-autocomplete #degree_auto="matAutocomplete">
                                    <mat-option *ngFor="let degree of degreelist" [value]="degree">
                                        {{degree}}
                                    </mat-option>
                                </mat-autocomplete>

                                <p *ngIf="education_form.get('degree').errors?.required && (education_form['controls'].degree.dirty || education_form['controls'].degree.touched)" [ngClass]="['text-left','my-1','text-danger']">
                                    Degree is required
                                </p>
                                <p *ngIf="education_form['controls'].degree.hasError('pattern')" class="text-danger f-12 pt-1">
                                    HTML tags are not allowed
                                </p>
                            </div>
                            <div class="f-12 font-weight-500 mb-4">
                                Name of School <span class="text-danger">*</span>

                                <input data-testid="auto-app-candidate-slider-input-7"
                                    (input)="searchSchool($event)"
                                    type="text"
                                    placeholder="Enter Name of School"
                                    #trigger="matAutocompleteTrigger"
                                    (keyup.enter)="trigger.closePanel()"
                                    class="wc-form-control nobg mt-2"
                                    formControlName="schoolname"
                                    [matAutocomplete]="school_auto"
                                />

                                <mat-autocomplete #school_auto="matAutocomplete">
                                    <mat-option *ngFor="let school of schoollist" [value]="school">
                                        {{school}}
                                    </mat-option>
                                </mat-autocomplete>
                                <p *ngIf="education_form.get('schoolname').errors?.required && (education_form['controls'].schoolname.dirty || education_form['controls'].schoolname.touched)" [ngClass]="['text-left','my-1','text-danger']">
                                    School Name is required
                                </p>
                                <p *ngIf="education_form['controls'].schoolname.hasError('pattern')" class="text-danger f-12 pt-1">
                                    HTML tags are not allowed
                                </p>
                            </div>

                            <div class="f-12 font-weight-500 mb-4">
                                Field of Study <span class="text-danger">*</span>
                                <input data-testid="auto-app-candidate-slider-input-8" type="text" placeholder="Enter Field of Study" class="wc-form-control nobg mt-2" formControlName="fieldstudyname" />
                                <p
                                    *ngIf="education_form.get('fieldstudyname').errors?.required && (education_form['controls'].fieldstudyname.dirty || education_form['controls'].fieldstudyname.touched)"
                                    [ngClass]="['text-left','my-1','text-danger']"
                                >
                                    Field of Study is required
                                </p>
                                <p *ngIf="education_form['controls'].fieldstudyname.hasError('pattern')" class="text-danger f-12 pt-1">
                                    HTML tags are not allowed
                                </p>
                            </div>

                            <div class="row mb-4">
                                <span class="col-6">
                                    <label class="f-12 font-weight-500 mb-2"> Start Year <span class="text-danger">*</span> </label>
                                    <div class="position-relative">
                                        <select data-testid="auto-app-candidate-slider-select-3" class="nobg wc-form-control" formControlName="startyear">
                                            <option [value]="null" disabled>Start Year</option>
                                            <option *ngFor="let x of year_list" [value]="x" selected>{{x}}</option>
                                        </select>
                                        <span class="selectdrop-down position-absolute tr0 p-none text-bluex"><i class="fas fa-calendar-minus f-12"></i> </span>
                                    </div>
                                    <p
                                        class="f-12 font-weight-500"
                                        *ngIf="education_form.get('startyear').errors?.required && (education_form['controls'].startyear.dirty || education_form['controls'].startyear.touched)"
                                        [ngClass]="['text-left','my-1','text-danger']"
                                    >
                                        Start Year is required
                                    </p>
                                </span>
                                <span class="col-6">
                                    <label class="f-12 font-weight-500 mb-2"> End Year <span class="text-danger">*</span> </label>
                                    <div class="position-relative">
                                        <select data-testid="auto-app-candidate-slider-select-4" class="nobg wc-form-control" formControlName="endyear">
                                            <option [value]="null" disabled>End Year</option>
                                            <option *ngFor="let x of year_list" [value]="x" selected>{{x}}</option>
                                        </select>
                                        <span class="selectdrop-down position-absolute tr0 p-none text-bluex"><i class="fas fa-calendar-minus f-12"></i> </span>
                                    </div>
                                    <p
                                        class="f-12 font-weight-500"
                                        *ngIf="education_form.get('endyear').errors?.required && (education_form['controls'].endyear.dirty || education_form['controls'].endyear.touched)"
                                        [ngClass]="['text-left','my-1','text-danger']"
                                    >
                                        End Year is required
                                    </p>
                                </span>
                            </div>

                            <p class="f-12 font-weight-500" *ngIf="education_form['controls'].endyear.hasError('incorretEducationYear')" [ngClass]="['text-left','my-1','text-danger']">End year should be greater than start year.</p>
                        </div>
                    </div>
                </form>
            </div>
            <!------------------------------------------------------- showEducationDetails --------------------------------------------------->

            <!------------------------------------------------------- showBasicDetails --------------------------------------------------->
            <div class="mr-2" *ngIf="showBasicDetails">
                <form [formGroup]="candidate_form">
                    <div class="row mr-2">
                        <div class="col">
                            <div class="f-12 font-weight-500 mb-3">
                                First Name <span class="text-danger">*</span>
                                <input data-testid="auto-app-candidate-slider-input-9" type="text" placeholder="Enter First Title" class="wc-form-control nobg mt-3px" formControlName="firstName" />
                                <p *ngIf="candidate_form.get('firstName').errors?.required && (candidate_form['controls'].firstName.dirty || candidate_form['controls'].firstName.touched)" [ngClass]="['text-left','my-1','text-danger']">
                                    First Name is required
                                </p>
                                <p *ngIf="candidate_form['controls'].firstName.hasError('pattern')" class="text-danger f-12 mb-0 mt-1">
                                    HTML tags are not allowed
                                </p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="f-12 font-weight-500 mb-3">
                                Last Name <span class="text-danger">*</span>
                                <input data-testid="auto-app-candidate-slider-input-10" type="text" placeholder="Enter Last Title" class="wc-form-control nobg mt-3px" formControlName="lastName" />
                                <p *ngIf="candidate_form.get('lastName').errors?.required && (candidate_form['controls'].lastName.dirty || candidate_form['controls'].lastName.touched)" [ngClass]="['text-left','my-1','text-danger']">
                                    Last Name is required
                                </p>
                                <p *ngIf="candidate_form['controls'].lastName.hasError('pattern')" class="text-danger f-12 mb-0 mt-1">
                                    HTML tags are not allowed
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="mr-4">
                        <div class="f-12 font-weight-500 mb-3">
                            Company Name <span class="text-danger">*</span>
                            <input data-testid="auto-app-candidate-slider-input-11"
                                (input)="searchCompany($event)"
                                type="text"
                                placeholder="Enter Company Name"
                                #trigger="matAutocompleteTrigger"
                                (keyup.enter)="trigger.closePanel()"
                                class="wc-form-control nobg mt-3px"
                                formControlName="companyName"
                                [matAutocomplete]="company_auto"
                            />

                            <mat-autocomplete #company_auto="matAutocomplete">
                                <mat-option *ngFor="let company of companylist" [value]="company">
                                    {{company}}
                                </mat-option>
                            </mat-autocomplete>

                            <p *ngIf="candidate_form.get('companyName').errors?.required && (candidate_form['controls'].companyName.dirty || candidate_form['controls'].companyName.touched)" [ngClass]="['text-left','my-1','text-danger']">
                                Company Name is required
                            </p>
                            <p *ngIf="candidate_form['controls'].companyName.hasError('pattern')" class="text-danger f-12 mb-0 mt-1">
                                HTML tags are not allowed
                            </p>
                        </div>

                        <div class="f-12 font-weight-500 mb-3">
                            Job Name <span class="text-danger">*</span>
                            <input data-testid="auto-app-candidate-slider-input-12"
                                (input)="searchJobs($event)"
                                type="text"
                                placeholder="Enter Job Title"
                                #trigger="matAutocompleteTrigger"
                                (keyup.enter)="trigger.closePanel()"
                                class="wc-form-control nobg mt-3px"
                                formControlName="jobName"
                                [matAutocomplete]="jobs_auto"
                            />

                            <mat-autocomplete #jobs_auto="matAutocomplete">
                                <mat-option *ngFor="let job of joblist" [value]="job">
                                    {{job}}
                                </mat-option>
                            </mat-autocomplete>

                            <p *ngIf="candidate_form.get('jobName').errors?.required && (candidate_form['controls'].jobName.dirty || candidate_form['controls'].jobName.touched)" [ngClass]="['text-left','my-1','text-danger']">
                                Job Name is required
                            </p>
                            <p *ngIf="candidate_form['controls'].jobName.hasError('pattern')" class="text-danger f-12 mb-0 mt-1">
                                HTML tags are not allowed
                            </p>
                        </div>

                        <div class="f-12 font-weight-500 mb-3">
                            Location <span class="text-danger">*</span>
                            <input data-testid="auto-app-candidate-slider-input-13"
                                (input)="searchLocation($event)"
                                type="text"
                                placeholder="Enter Work Location"
                                #trigger="matAutocompleteTrigger"
                                (keyup.enter)="trigger.closePanel()"
                                class="wc-form-control nobg mt-3px"
                                formControlName="worklocation"
                                [matAutocomplete]="location_auto"
                            />

                            <mat-autocomplete #location_auto="matAutocomplete">
                                <mat-option *ngFor="let location of locationlist" [value]="location">
                                    {{location}}
                                </mat-option>
                            </mat-autocomplete>
                            <p *ngIf="candidate_form.get('worklocation').errors?.required && (candidate_form['controls'].worklocation.dirty || candidate_form['controls'].worklocation.touched)" [ngClass]="['text-left','my-1','text-danger']">
                                Work Location is required
                            </p>
                            <p *ngIf="candidate_form['controls'].worklocation.hasError('pattern')" class="text-danger f-12 mb-0 mt-1">
                                HTML tags are not allowed
                            </p>
                        </div>

                        <div class="f-12 font-weight-500 mb-3">
                            Public Profile Link <span class="text-danger">*</span>
                            <input data-testid="auto-app-candidate-slider-input-14" type="text" placeholder="Enter Public Profile Link" class="wc-form-control nobg mt-3px" formControlName="publicProfileLink" />
                            <p
                                *ngIf="candidate_form.get('publicProfileLink').errors?.required && (candidate_form['controls'].publicProfileLink.dirty || candidate_form['controls'].publicProfileLink.touched)"
                                [ngClass]="['text-left','my-1','text-danger']"
                            >
                                Public Profile Link is required
                            </p>
                            <p class="text-danger f-12 pt-1" *ngIf="candidate_form['controls'].publicProfileLink.hasError('pattern')">
                                Must be a valid URL
                            </p>
                        </div>
                    </div>
                </form>
            </div>
            <!------------------------------------------------------- showBasicDetails --------------------------------------------------->

            <!------------------------------------------------------- showAdditionalDetails --------------------------------------------------->
            <div class="mr-2" *ngIf="showAdditionalDetails">
                <div class="row mb-4">
                    <div class="col d-flex justify-content-between">
                        <span class="font-weight-500">Additional Information</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-11 mb-1">
                        <p class="f-12 font-weight-500 mb-2">Skills <span class="text-danger">*</span></p>
                        <input data-testid="auto-app-candidate-slider-input-15"
                            (input)="searchSkills()"
                            type="text"
                            placeholder="Enter Skills"
                            #trigger="matAutocompleteTrigger"
                            (keyup.enter)="AddSkills(); trigger.closePanel()"
                            class="wc-form-control nobg"
                            #skillsEl
                            [(ngModel)]="skills"
                            id="skillsInput"
                            [matAutocomplete]="skills_auto"
                        />
                    </div>

                    <mat-autocomplete #skills_auto="matAutocomplete" (optionSelected)="AddSkills($event.option.value)">
                        <mat-option *ngFor="let skill of skillsList" [value]="skill">
                            {{skill}}
                        </mat-option>
                    </mat-autocomplete>

                    <div class="col-12">
                        <div class="customChip mr-2 mt-1 mb-1" *ngFor="let skills of skillsdata; let i = index;" title="{{skills}}">
                            <div class="chipname">{{skills}}</div>
                            <div class="ml-2 pointer"><i class="fal fa-times" aria-hidden="true" (click)="removeskills(i);"></i></div>
                        </div>
                    </div>
                    <p class="f-12 font-weight-500 ml-3" *ngIf="skillerror" [ngClass]="['text-left','my-1','text-danger']">Atleast one Skill is required</p>
                </div>
            </div>

            <!------------------------------------------------------- shoeEditContactDetails --------------------------------------------------->

            <div class="mr-2" *ngIf="showEditContacts">
                <div class="row mb-4">
                    <div class="col d-flex justify-content-between">
                        <span class="font-weight-500">Contact Details</span>
                    </div>
                </div>
                <form [formGroup]="contact_form">
                    <div class="row mb-3">
                        <div class="col-12 mb-1" formArrayName="sociallinks">
                            <p class="f-12 font-weight-500 mb-2">
                                Social Profiles
                                <i class="fas fa-info-circle text-dis" [ngbTooltip]="pdlenriched" placement="right"></i>
                            </p>
                            <ng-template #pdlenriched>
                                <span class="f-12"> The contacts that are added by enriching the profile cannot be edited </span>
                            </ng-template>
                            <section *ngFor="let links of contact_form.controls.sociallinks['controls']; let i=index" [formGroupName]="i" class="mb-2">
                                <div class="justify-content-between d-flex">
                                    <input data-testid="auto-app-candidate-slider-input-16" type="text" placeholder="Enter Social Profile Links" class="wc-form-control nobg col-11" formControlName="link" />

                                    <span class="dropdown ats-dropBtn mx-1 mt-1" *ngIf="contact_form.controls.sociallinks['controls'].length > 1 && links.value.pdlenriched != 1">
                                        <button data-testid="auto-app-candidate-slider-button-3" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton" appDropdownToggle aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v f-16 gray-text"></i>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="userDropdownButton">
                                            <a data-testid="auto-app-candidate-slider-a-19" class="dropdown-item f-14" routerLinkActive="active" (click)="deleteSocialLink(links.value,i)">Delete</a>
                                        </div>
                                    </span>
                                </div>
                                <p class="text-danger f-12 pt-1" *ngIf="links['controls'].link.hasError('pattern')">Please Enter Valid Link</p>
                                <p *ngIf="links['controls'].link.errors?.required && (links['controls'].link.dirty || links['controls'].link.touched)" class="text-danger f-12 pt-1">
                                    Link is required
                                </p>
                            </section>
                            <span class="trx pointer text-bluex f-12 font-weight-500" (click)="addSocialProfiles('socialprofile')"> + ADD</span>
                        </div>

                        <div class="col-12 mb-1 mt-4" formArrayName="contactemails">
                            <p class="f-12 font-weight-500 mb-2">
                                Email Id
                                <i class="fas fa-info-circle text-dis" [ngbTooltip]="pdlenriched" placement="right"></i>
                            </p>
                            <ng-template #pdlenriched>
                                <span class="f-12"> The contacts that are added by enriching the profile cannot be edited </span>
                            </ng-template>
                            <section *ngFor="let emails of contact_form.controls.contactemails['controls']; let i=index " [formGroupName]="i" class="mb-2">
                                <div class="justify-content-between d-flex">
                                    <input data-testid="auto-app-candidate-slider-input-17" type="text" placeholder="Enter Email Id" class="wc-form-control nobg col-11" formControlName="email" />
                                    <span *ngIf="emails.value.isprimary == 1">
                                        <i class="fas fa-check-circle mt-2 ml-1 pointer text-bluex" title="Primary EmailId"></i>
                                    </span>

                                    <span class="dropdown ats-dropBtn mx-1 mt-1" *ngIf="emails.value.isprimary == 0 && emails['controls'].email.value && emails['controls'].email.valid">
                                        <button data-testid="auto-app-candidate-slider-button-4" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton" appDropdownToggle aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v f-16 gray-text"></i>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="userDropdownButton">
                                            <a data-testid="auto-app-candidate-slider-a-20" class="dropdown-item f-14" routerLinkActive="active" (click)="MakeEmailPrimary(emails.value,i)">Make Primary</a>
                                            <a data-testid="auto-app-candidate-slider-a-21" *ngIf="contact_form.controls.contactemails['controls'].length > 1  && emails.value.pdlenriched != 1" class="dropdown-item f-14" routerLinkActive="active" (click)="deleteEmails(emails.value,i)">
                                                Delete
                                            </a>
                                        </div>
                                    </span>
                                </div>
                                <p class="text-danger f-12 pt-1" *ngIf="emails['controls'].email.hasError('pattern')">Must be a valid EmailId</p>
                                <p *ngIf="emails['controls'].email.errors?.required && (emails['controls'].email.dirty || emails['controls'].email.touched)" class="text-danger f-12 pt-1">
                                    Email is required
                                </p>
                            </section>
                            <span class="trx pointer text-bluex f-12 font-weight-500" (click)="addSocialProfiles('emails')"> + ADD</span>
                        </div>

                        <div class="col-12 mb-1 mt-4" formArrayName="phonenumber">
                            <p class="f-12 font-weight-500 mb-2">
                                Phone Number
                                <i class="fas fa-info-circle text-dis" [ngbTooltip]="pdlenriched" placement="right"></i>
                            </p>
                            <ng-template #pdlenriched>
                                <span class="f-12"> The contacts that are added by enriching the profile cannot be edited </span>
                            </ng-template>
                            <section *ngFor="let contact of contact_form.controls.phonenumber['controls']; let i=index" [formGroupName]="i" class="mb-2">
                                <div class="justify-content-between d-flex">
                                    <div class="col-11 pl-0 pr-0">
                                        <ngx-intl-tel-input
                                            [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
                                            [enableAutoCountrySelect]="true"
                                            [enablePlaceholder]="false"
                                            [searchCountryFlag]="true"
                                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                            [selectFirstCountry]="false"
                                            [selectedCountryISO]="CountryISO.India"
                                            [maxLength]="25"
                                            [phoneValidation]="true"
                                            [separateDialCode]="separateDialCode"
                                            name="phone"
                                            formControlName="phone"
                                            class="f-12"
                                        >
                                        </ngx-intl-tel-input>
                                    </div>
                                    <div class="mt-1">
                                        <span *ngIf="contact.value.isprimary == 1">
                                            <i class="fas fa-check-circle mt-2 ml-1 pointer text-bluex" title="Primary Contact Number"></i>
                                        </span>

                                        <span class="dropdown ats-dropBtn mx-1 mt-1" *ngIf="contact.value.isprimary == 0 && contact['controls'].phone.value && contact['controls'].phone.valid">
                                            <button data-testid="auto-app-candidate-slider-button-5" class="ats-btn btn-break dropdown-toggle ml-3px" type="button" id="userDropdownButton" appDropdownToggle aria-haspopup="true" aria-expanded="false">
                                                <i class="fas fa-ellipsis-v f-16 gray-text"></i>
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="userDropdownButton">
                                                <a data-testid="auto-app-candidate-slider-a-22" class="dropdown-item f-14" routerLinkActive="active" (click)="MakeContactPrimary(contact.value,i)">Make Primary</a>
                                                <a data-testid="auto-app-candidate-slider-a-23"
                                                    *ngIf="contact_form.controls.phonenumber['controls'].length > 1  && contact.value.pdlenriched != 1"
                                                    class="dropdown-item f-14"
                                                    routerLinkActive="active"
                                                    (click)="deleteContacts(contact.value,i)"
                                                >
                                                    Delete
                                                </a>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <p class="text-danger pt-1 f-12 mb-3px" *ngIf="!contact['controls'].phone.valid">Please Enter Valid Number</p>
                                <p *ngIf="contact['controls'].phone.errors?.required && (contact['controls'].phone.dirty || contact['controls'].phone.touched)" class="text-danger f-12 pt-1">
                                    Phone Number is required
                                </p>
                            </section>
                            <span class="trx pointer text-bluex f-12 font-weight-500" (click)="addSocialProfiles('phone')"> + ADD</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="row pos-abs-bottom-0">
        <div class="col px-0" *ngIf="showEditContacts">
            <button data-testid="auto-app-candidate-slider-button-6" type="button" class="btn-trms-small" data-dismiss="modal" (click)="saveContactDetails()">Save</button>
        </div>
        <div class="col px-0" *ngIf="showExperienceDetails">
            <button data-testid="auto-app-candidate-slider-button-7" type="button" class="btn-trms-small" data-dismiss="modal" (click)="addexperience()">Save</button>
        </div>
        <div class="col px-0" *ngIf="showEducationDetails">
            <button data-testid="auto-app-candidate-slider-button-8" type="button" class="btn-trms-small" data-dismiss="modal" (click)="addeducation()">Save</button>
        </div>
        <div class="col px-0" *ngIf="showBasicDetails">
            <button data-testid="auto-app-candidate-slider-button-9" type="button" class="btn-trms-small" data-dismiss="modal" (click)="updateBasicDetails()">Save</button>
        </div>
        <div class="col px-0" *ngIf="showAdditionalDetails">
            <button data-testid="auto-app-candidate-slider-button-10" type="button" class="btn-trms-small" data-dismiss="modal" (click)="addAdditionDetails()">Save</button>
        </div>
    </div>

</div>
<div class="w3-overlay w3-animate-opacity close-overlay-transition" (click)="dismissCandidateSlider()" id="myOverlay2"></div>


  <ng-template #deleteexperience>
    <div class="modal-header b pb-0">
      <span class="modal-title font-weight-500" id="experience">Are you sure you want to delete this Experience?</span>
      <button data-testid="auto-app-candidate-slider-button-11" type="button" class="close font-weight-normal px-3 py-2" data-dismiss="modal" aria-label="Close"
        (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row mt-3">
        <div class="col d-flex justify-content-end">
          <button data-testid="auto-app-candidate-slider-button-12" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">NO</button>
          <button data-testid="auto-app-candidate-slider-button-13" class="btn-trms-small" (click)="DeleteExperienceDetails()">YES</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #deletecv>
    <div class="modal-header b pb-0">
      <span class="modal-title  font-weight-500" id="experience">Are you sure you want to delete this document?</span>
      <button data-testid="auto-app-candidate-slider-button-14" type="button" class="close font-weight-normal px-3 py-2" data-dismiss="modal" aria-label="Close"
        (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row mt-3">
        <div class="col d-flex justify-content-end">
          <button data-testid="auto-app-candidate-slider-button-15" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">NO</button>
          <button data-testid="auto-app-candidate-slider-button-16" class="btn-trms-small" (click)="DeleteCV()">YES</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #deleteeducation>
    <div class="modal-header b pb-0">
      <span class="modal-title  font-weight-500" id="experience">Are you sure you want to delete this Education?</span>
      <button data-testid="auto-app-candidate-slider-button-17" type="button" class="close font-weight-normal px-3 py-2" data-dismiss="modal" aria-label="Close"
        (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row mt-3">
        <div class="col d-flex justify-content-end">
          <button data-testid="auto-app-candidate-slider-button-18" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">NO</button>
          <button data-testid="auto-app-candidate-slider-button-19" class="btn-trms-small" (click)="DeletedEducationDetails()">YES</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #deletelink>
    <div class="modal-header b pb-0">
      <span class="modal-title  font-weight-500" id="experience">Are you sure you want to delete this Social Profile Link?</span>
      <button data-testid="auto-app-candidate-slider-button-20" type="button" class="close font-weight-normal px-3 py-2" data-dismiss="modal" aria-label="Close"
        (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row mt-3">
        <div class="col d-flex justify-content-end">
          <button data-testid="auto-app-candidate-slider-button-21" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">NO</button>
          <button data-testid="auto-app-candidate-slider-button-22" class="btn-trms-small" (click)="DeleteSocialProfileLink()">YES</button>
        </div>
      </div>
    </div>
  </ng-template>


  <ng-template #deletemail>
    <div class="modal-header b pb-0">
      <h5 class="modal-title" id="experience"></h5>
      <button data-testid="auto-app-candidate-slider-button-23" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body pb-6">
      <div class="row mb-6">
        <div class="col text-center">
          <p>Are you sure you want to delete this Email ID?
          <p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-candidate-slider-button-24" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">NO</button>
          <button data-testid="auto-app-candidate-slider-button-25" class="btn-trms-small" (click)="DeleteEmailID()">YES</button>
        </div>
      </div>
    </div>
  </ng-template>



  <ng-template #deletecontact>
    <div class="modal-header b pb-0">
      <h5 class="modal-title" id="experience"></h5>
      <button data-testid="auto-app-candidate-slider-button-26" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body pb-6">
      <div class="row mb-6">
        <div class="col text-center">
          <p>Are you sure you want to delete this Contact Number?</p>

        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-candidate-slider-button-27" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">NO</button>
          <button data-testid="auto-app-candidate-slider-button-28" class="btn-trms-small" (click)="deleteContactNumber()">YES</button>
        </div>
      </div>
    </div>
  </ng-template>


    <ng-template #deletecandidate>
        <div class="modal-header b pb-0">
            <h5 class="f-14 font-weight-600" id="experience">Archive Candidate</h5>
            <button data-testid="auto-app-candidate-slider-button-29" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close" (click)="modalService.dismissAll()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body pb-3 pt-0">
            <div class="row mb-3">
                <div class="col">
                    <p>Are you sure you want to delete this Candidate?</p>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex justify-content-end">
                    <button data-testid="auto-app-candidate-slider-button-30" class="btn-trms-white mr-3" (click)="modalService.dismissAll()">No</button>
                    <button data-testid="auto-app-candidate-slider-button-31" class="btn-trms-small" (click)="deletecandidatedetails()">Yes</button>
                </div>
            </div>
        </div>
    </ng-template>
  <ng-template #addCandidateToEmailCampaign>
    <div class="modal-header b pb-0">
      <h5 class="f-14 font-weight-600" id="experience">Add Candidate to Email Campaign</h5>
      <button data-testid="auto-app-candidate-slider-button-32" type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close"
        (click)="closeActiveModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
        <div class="modal-body pb-3 pt-0">
            <div class="row mb-2">
        <div class="col">
          <input data-testid="auto-app-candidate-slider-input-18" type="text" class="wc-form-control no-shadow w-100 inputheight mb-2"
            placeholder="Enter Campaign Name...." [formControl]="campaign_input" [matAutocomplete]="campaign_name"
            (click)="onTypeAheadSearch($event.target.value)" />
          <p *ngIf="campaign_input.errors?.required && (campaign_input.dirty || campaign_input.touched)"
            class="f-12 text-danger">Campaign Name is required</p>

          <mat-autocomplete #campaign_name="matAutocomplete" (optionSelected)="onCampaignSelected($event.option.value)">
            <mat-option *ngFor="let campaign of campaignList" [value]="campaign" [disabled]="campaign.remaining_targets <= 0">
              <div class="d-flex justify-content-between align-items-center">
                <span>{{ campaign.campaign_name }}</span> <span class="badge badge-light border f-12 font-weight-normal text-9696" *ngIf="campaign.remaining_targets <= 0">Campaign limits reached</span>
              </div>
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
      <div class="row mb-0">
        <div class="col  d-flex justify-content-end">
          <button data-testid="auto-app-candidate-slider-button-33" class="btn-trms-small" (click)="!isLoadingEmailCampaignApi && addToEmailCampaign()"
            [class.disabled]="!campaign_input.valid">
            <span *ngIf="!isLoadingEmailCampaignApi">
                Add
              </span>
              <span *ngIf="isLoadingEmailCampaignApi">
                <img style="width: 20px;" src="../../../assets/rolling-loader-white.gif" alt="">
              </span>
        </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #addCandidateToScreenAiModal>
  <div class="modal-content">
    <div class="modal-header b pb-0">
      <h5 class="f-14 font-weight-600" id="downloadCSVModalHeading">Add to Screen AI</h5>
      <button data-testid="auto-app-candidate-slider-button-34" type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close"
        (click)="closeActiveModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body pb-3 pt-0">
      <div *ngIf="!screenAiDuplicateCheckDone">
        <div class="row mb-2 mt-2">
          <div class="col">
            <input data-testid="auto-app-candidate-slider-input-19"
              type="text"
              class="wc-form-control no-shadow w-100 inputheight mb-2"
              placeholder="Enter Job Name...."
              [formControl]="job_input"
              [matAutocomplete]="job_name"
              (click)="getAllScreenAIJobs()"
            />
            <p *ngIf="job_input.errors?.required && (job_input.dirty || job_input.touched)"
                    class="f-12 text-danger">Job Name is required</p>
            <mat-autocomplete #job_name="matAutocomplete" (optionSelected)="onJobSelected($event.option.value)">
              <mat-option *ngFor="let job of jobList" [value]="job" [disabled]="isScreeningInProgress(job)" [matTooltip]="getTooltipText(job)" [matTooltipClass]="{ 'eu-tooltip text-black': true }" matTooltipPosition="above">
                {{ job.name }} <span class="float-right text-right ml-auto f-12 mt-2 text-9696" *ngIf="job.batch_status === 'pending'">Screening in progress</span>
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
        <div class="row mb-0">
          <div class="col  d-flex justify-content-end">
            <button data-testid="auto-app-candidate-slider-button-35" class="btn-trms-small" (click)="!isLoadingScreenAiApi && addToScreenAi()" [disabled]="!job_input.valid">
              <span *ngIf="!isLoadingScreenAiApi">
                Add
              </span>
              <span *ngIf="isLoadingScreenAiApi">
                <img style="width: 20px;" src="../../../assets/rolling-loader-white.gif" alt="">
              </span>
            </button>
          </div>
        </div>
        </div>
      <ng-container *ngIf="screenAiDuplicateCheckDone">
        <div class="px-3">
          <p>{{postAddMssg}}</p>
          <div class="float-right d-flex flex-row justify-content-end mb-2">
            <button data-testid="auto-app-candidate-slider-button-36" class="outlined-button" *ngIf="addCandidateSuccess" style="width: fit-content; padding: 1rem; border-radius: .3125rem;" (click)="redirectToScreenAi()">
              View Screen AI
            </button>
            <button data-testid="auto-app-candidate-slider-button-37"  (click)="closeActiveModal()" class="ml-2 enabled-button" style="width: fit-content; padding: 1rem; border-radius: .3125rem;">
              <span *ngIf="addCandidateSuccess" (click)="ngOnInit()">Continue Search</span>
              <span *ngIf="!addCandidateSuccess">Close</span>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
    </div>
</ng-template>

    <ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
        <span class="successCheck"><i class="fal fa-check"></i> </span>
        <span class="successmsg">{{ successMessage }}</span>
    </ngb-alert>

    <ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
        <span class="errorCheck"><i class="fal fa-times"></i></span>
        <span class="errormsg"> {{ errorMessage }} </span>
    </ngb-alert>

<ng-template #noCreditsCE class="modal">
    <div class="modal-content">
        <div class="modal-body px-6 pb-6 pt-3">
            <div class="row mb-3">
                <div class="col pb-5">
                    <button data-testid="auto-app-candidate-slider-button-38" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close" (click)="modalService.dismissAll()">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
            </div>
            <div class="row mb-6">
                <div class="col text-center mb-4">
                    <img src="../../../assets/images/wallet.png" alt="img-fluid" />
                </div>
            </div>
            <div class="row mb-3">
                <div class="col text-center">
                    <p class="font-weight-500 f-16 mb-2">Upgrade to keep going</p>
                    <p class="" *ngIf="!isteamMember">You have exhausted your limit for contacts enmrichments</p>
                    <p class="" *ngIf="isteamMember">You have exhausted your limit to contacts enmrichments Request more credits from your team admin to keep going</p>
                </div>
            </div>
            <div class="row" *ngIf="!isteamMember">
                <div class="col-md-10 mx-auto d-flex">
                    <!-- <button data-testid="auto-app-candidate-slider-button-39" class="col-md-4 mx-auto py-3 wc-ghostBtn" (click)="modaldismiss()">CANCEL</button> -->
                    <button data-testid="auto-app-candidate-slider-button-40" class="btn-trms-medium" (click)="route2pricing()">Upgrade plan</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #addToEmailCampaignWithViewCampaign let-modal>
  <div class=" p-2 text-white" style="background-color: #53EBA4;">
    <p class="mb-0 d-flex align-items-center"><span><i class="fa-solid fa-check mx-2 text-white f-18"></i></span> <span>Profile added to Campaign</span><span class="text-truncate pointer font-weight-600" style="text-decoration: underline;" (click)="redirectToEmailCampaign(selectedCampaign?.campaign_id)">"{{campaignName}}".</span></p>
  </div>
</ng-template>

